import {Theme} from "@/vuex/models/theme";


export default class BrowserState {
    public theme!: Theme;
}